
import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-auto',
  templateUrl: './auto.component.html',
  styleUrls: ['./auto.component.css']
})
export class AutoComponent implements OnInit {

  @Input() adressType: string;
  @Input() LatLng = {}
  @Input() strictBounds: boolean
  @Input() title: boolean

  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;
  defaultBounds
  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['strictBounds']['previousValue'] != undefined) {
      this.getPlaceAutocomplete();
    }
  }



  private getPlaceAutocomplete() {

    let center: any;

    if (this.LatLng != undefined) {
      center = { lat: this.LatLng['lat'], lng: this.LatLng['lng'] };
    }

    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };
    const options = {
      bounds: defaultBounds,
      radius: '10000000',
      strictBounds: this.strictBounds,
    }
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, options)
    // {
    //     componentRestrictions: { country: 'US' },
    //     types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    // });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    const addressComponents = this.parseAddressComponents(place);
    console.log('Place object from Google API:', place);
    console.log('Parsed address components:', addressComponents)
    this.setAddress.emit(place);
  }

  private parseAddressComponents(place: any) {
    const addressComponents = place.address_components;

    const getComponent = (types: string[]) => {
      const component = addressComponents.find((comp: any) => types.some(type => comp.types.includes(type)));
      return component ? component.long_name : '';
    };

    return {
      streetAddress: `${getComponent(['street_number'])} ${getComponent(['route'])}`,
      city: getComponent(['locality', 'administrative_area_level_2']),
      state: getComponent(['administrative_area_level_1']),
      postalCode: getComponent(['postal_code']),
      country: getComponent(['country'])
    };
  }

}
